import memoize from 'memoizee';
import config from '@/constants/config';

const getFactoryV2Gauges = memoize(async () => {
  let gaugesData;
  const { data } = await (config.factoryV2GaugesEndpoint ? (await fetch(config.factoryV2GaugesEndpoint)).json() : { data: { gauges: [] } });

  if (data.gauges) gaugesData = data.gauges;
  else gaugesData = data;

  // Exclude lending vault gauges
  gaugesData = (Array.isArray(gaugesData) ? gaugesData : Object.values(gaugesData)).filter(({ isPool }) => isPool !== false); // isPool can be either bool or undefined depending on the source

  return gaugesData;
}, {
  promise: true,
  maxAge: 60 * 1000, // 1m
});

export default getFactoryV2Gauges;
